<template>
  <div>
    <view-title>
      <v-icon class="primary--text mr-4" v-if="$vuetify.breakpoint.smAndUp">fas fa-search</v-icon>
      {{ $route.params.id ? "Editar" : "Adicionar" }} Acervo {{ acervo && acervo.tipoPublicacao }}
    </view-title>
    <v-container>
      <v-row v-if="$route.params.id">
        <v-col class="px-10">
          <span class="primary--text title mb-2 font-weight-bold">Registro:</span>
          <span class="title mb-2 font-weight-bold">
            <!-- eslint-disable-next-line max-len -->
            {{
              `${(editItem &&
                editItem.suporteBase &&
                editItem.suporteBase[0] &&
                editItem.suporteBase[0].registro1) ||
                ""} ${(editItem &&
                editItem.suporteBase &&
                editItem.suporteBase[0] &&
                editItem.suporteBase[0].registro2) ||
                ""}`
            }}</span
          >
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-card>
            <v-card-text class="pa-10">
              <v-form ref="editForm">
                <collection-upsert-depoimentos
                  v-if="$route.params.acervo === 'depoimentos'"
                  :edit-item="editItem"
                  :on-edit-change="onEditChange"
                  :idiomas="idiomas"
                  :segmentos="segmentos"
                />
                <collection-upsert-audiovisual
                  v-if="$route.params.acervo === 'audiovisual'"
                  :edit-item="editItem"
                  :on-edit-change="onEditChange"
                  :idiomas="idiomas"
                  :segmentos="segmentos"
                />
                <collection-upsert-fotografico
                  v-if="$route.params.acervo === 'fotografico'"
                  :edit-item="editItem"
                  :on-edit-change="onEditChange"
                  :segmentos="segmentos"
                />
                <collection-upsert-pecas
                  v-if="$route.params.acervo === 'pecas'"
                  :edit-item="editItem"
                  :on-edit-change="onEditChange"
                  :segmentos="segmentos"
                  :tipos-objeto="tiposObjeto"
                />
                <collection-upsert-textual
                  v-if="$route.params.acervo === 'textual'"
                  :edit-item="editItem"
                  :idiomas="idiomas"
                  :on-edit-change="onEditChange"
                  :segmentos="segmentos"
                  :tipos-objeto="tiposObjeto"
                />
                <collection-upsert-referencia
                  v-if="$route.params.acervo === 'referencia'"
                  :edit-item="editItem"
                  :on-edit-familias-change="onEditFamiliasChange"
                  :on-edit-change="onEditChange"
                  :segmentos="segmentos"
                  :idiomas="idiomas"
                  :familia-publicacoes="familiaPublicacoes"
                  :familias="familias"
                />
                <form-title title="Conteúdo" />
                <v-row>
                  <v-col cols="12" sm="6" v-if="editItem">
                    <div class="font-weight-bold pb-2">Descrição *</div>
                    <vue-editor
                      id="editor1"
                      :editorToolbar="customToolbar"
                      :rules="[rules.required]"
                      :value="editItem.conteudo"
                      required
                      @input="onEditChange({ conteudo: $event })"
                    ></vue-editor>
                  </v-col>
                  <v-col cols="12" sm="6" v-if="editItem">
                    <div class="font-weight-bold pb-2">Observação</div>
                    <vue-editor
                      id="editor2"
                      :editorToolbar="customToolbar"
                      :value="editItem.observacao"
                      @input="onEditChange({ observacao: $event })"
                    ></vue-editor>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6">
                    <form-title title="Palavras-chave (aperte Enter após digitar)" />
                    <v-text-field
                      v-model="palavraChave"
                      placeholder="Digite a palavra-chave e aperte Enter"
                      @keyup.enter.native="
                        onAddPalavrasChave(palavraChave);
                        palavraChave = '';
                      "
                    >
                    </v-text-field>
                    <v-chip-group>
                      <v-chip
                        v-for="pc in palavrasChave"
                        :key="pc.id"
                        close
                        @click:close="onDeletePalavrasChave(pc)"
                      >
                        {{ pc.palavrachave }}
                      </v-chip>
                    </v-chip-group>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <form-title title="Links externos" />
                    <v-text-field
                      v-model="linkExterno"
                      placeholder="Digite o endereço eletrônico e aperte Enter"
                      @keyup.enter.native="
                        onAddLinkExterno(linkExterno);
                        linkExterno = '';
                      "
                    >
                    </v-text-field>
                    <v-chip-group>
                      <v-chip
                        v-for="link in linksExternos"
                        :key="link"
                        close
                        @click:close="onDeleteLinkExterno(link)"
                      >
                        {{ link }}
                      </v-chip>
                    </v-chip-group>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6">
                    <form-title title="Permissão do acervo *" />
                    <v-radio-group
                      @change="onEditChange({ nivel: $event })"
                      :value="editItem.nivel"
                      row
                      :rules="[rules.required]"
                    >
                      <v-radio label="Privado" value="privado"></v-radio>
                      <v-radio label="Público" value="publico"></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
                <form-title title="Tipo de suporte">
                  <v-btn text color="accent" class="float-right" @click="onAddSb"
                    >Adicionar novo +</v-btn
                  >
                </form-title>
                <v-row>
                  <v-col cols="12" v-for="(sb, p) in editItem.suporteBase" :key="p">
                    <v-row v-if="p !== 0" class="mb-5" />
                    <v-row>
                      <v-col cols="12" sm="6">
                        <v-autocomplete
                          label="Tipo de suporte *"
                          :items="suportes"
                          item-text="descricao"
                          :menu-props="{ overflowY: true }"
                          item-value="id"
                          placeholder="Selecione um suporte *"
                          :rules="[rules.required]"
                          :value="sb.idTipoSuporte"
                          @input="
                            onPatchSb({
                              p,
                              idTipoSuporte: $event
                            })
                          "
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-select
                          label="Estado de conservação"
                          :items="estados"
                          clearable
                          item-text="descricao"
                          item-value="id"
                          placeholder="Selecione um estado de conservação"
                          :value="sb.idConservacao"
                          @input="
                            onPatchSb({
                              p,
                              idConservacao: $event
                            })
                          "
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="4">
                        <v-text-field
                          label="Quantidade *"
                          :value="sb.quantidade"
                          placeholder="0"
                          :rules="[rules.required]"
                          type="number"
                          min="0"
                          step="1"
                          @input="
                            onPatchSb({
                              p,
                              quantidade: $event
                            })
                          "
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="4">
                        <v-text-field
                          label="Localização *"
                          :value="sb.localizacaoFisica"
                          placeholder="Informe a localização *"
                          :rules="[rules.required]"
                          @input="
                            onPatchSb({
                              p,
                              localizacaoFisica: $event
                            })
                          "
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="3">
                        <v-text-field
                          label="Extensão"
                          :value="sb.extensao"
                          placeholder="Informe a extensão"
                          @input="
                            onPatchSb({
                              p,
                              extensao: $event
                            })
                          "
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="1" class="pb-0">
                        <v-btn
                          text
                          color="accent"
                          class="font-weight-light"
                          v-if="p !== 0"
                          @click="onRemoveSb(p)"
                        >
                          <v-icon color="red">fas fa-trash</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-row
                    v-if="$route.params.acervo === 'depoimentos'"
                  >
                    <v-col cols="12" sm="6">
                      <form-title title="Direito Autoral e Direito de Imagem" />
                      <v-checkbox
                        label="Direito Autoral"
                        @change="onEditChange({ autorizacaoFotografo: $event })"
                        :value="editItem.autorizacaoFotografo"
                        row
                      />
                      <v-checkbox
                        label="Direito de Imagem e Voz"
                        @change="onEditChange({ autorizacaoFotografado: $event })"
                        :value="editItem.autorizacaoFotografado"
                        row
                      />
                    </v-col>
                  </v-row>
                  <v-row
                    v-if="$route.params.acervo === 'audiovisual'"
                  >
                    <v-col cols="12" sm="6">
                      <form-title title="Direito Autoral e Direito de Imagem" />
                      <v-checkbox
                        label="Direito Autoral"
                        @change="onEditChange({ autorizacaoFotografo: $event })"
                        :value="editItem.autorizacaoFotografo"
                        row
                      />
                      <v-checkbox
                        label="Direito de Imagem e Voz"
                        @change="onEditChange({ autorizacaoFotografado: $event })"
                        :value="editItem.autorizacaoFotografado"
                        row
                      />
                    </v-col>
                  </v-row>
                  <v-row
                    v-if="$route.params.acervo === 'fotografico'"
                  >
                    <v-col cols="12" sm="6">
                      <form-title title="Direito Autoral e Direito de Imagem" />
                      <v-checkbox
                        label="Direito Autoral"
                        @change="onEditChange({ autorizacaoFotografo: $event })"
                        :value="editItem.autorizacaoFotografo"
                        row
                      />
                      <v-checkbox
                        label="Direito de Imagem"
                        @change="onEditChange({ autorizacaoFotografado: $event })"
                        :value="editItem.autorizacaoFotografado"
                        row
                      />
                    </v-col>
                  </v-row>
                </v-row>
                <v-row>
                  <v-col cols="12" id="upload">
                    <form-title title="Anexos" />
                    <div v-if="documentos && documentos.length > 0" class="mb-4 d-block">
                      <v-checkbox
                        :indeterminate="
                          selectedDocumentosCount > 0 &&
                          selectedDocumentosCount < documentos.length
                        "
                        :input-value="isAllDocumentosSelected"
                        @change="onSelectAllChange"
                        label="Selecionar todos"
                        class="d-inline-block mt-0"
                        hide-details
                      />
                      <span v-if="selectedDocumentosCount > 0" class="ml-4">
                        {{ selectedDocumentosCount }} de {{ documentos.length }}
                        selecionado(s)
                      </span>
                      <div v-if="hasSelectedDocumentos" class="float-right">
                        <v-btn
                          text
                          color="primary"
                          small
                          class="mr-2"
                          :loading="loadingBulkDocumentos"
                          :disabled="loadingBulkDocumentos"
                          @click="onBulkUpdateNivelDocumentos('publico')"
                        >
                          Tornar selecionados públicos
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          small
                          class="mr-2"
                          :loading="loadingBulkDocumentos"
                          :disabled="loadingBulkDocumentos"
                          @click="onBulkUpdateNivelDocumentos('privado')"
                        >
                          Tornar selecionados privados
                        </v-btn>
                        <v-btn
                          text
                          color="error"
                          small
                          :loading="loadingBulkDocumentos"
                          :disabled="loadingBulkDocumentos"
                          @click="confirmBulkDeleteSelected"
                        >
                          Excluir selecionados
                        </v-btn>
                      </div>
                    </div>
                    <v-data-iterator
                      :items="documentos"
                      :footer-props="footerProps"
                      :options="options"
                      class="elevation-0"
                    >
                      <template v-slot:default="props">
                        <v-row v-if="documentos.length" style="width: 100%;">
                          <v-col
                            v-for="item in props.items"
                            :key="item.id"
                            cols="12"
                            sm="3"
                            md="3"
                            lg="2"
                            style="position: relative;"
                          >
                            <v-checkbox
                              :input-value="selectedDocumentos.includes(item.id)"
                              @change="onToggleSelectDocumento(item.id)"
                              absolute
                              top
                              left
                              style="z-index: 2;"
                            />
                            <v-btn
                              icon
                              absolute
                              right
                              color="error"
                              @click="onDeleteDocumento(item)"
                            >
                              <v-icon>fas fa-trash</v-icon>
                            </v-btn>
                            <anexo-image :documento="item" />
                            <v-row>
                              <v-col class="pt-0">
                                <v-radio-group
                                  @change="onEditDocumento({ ...item, nivel: $event })"
                                  :value="item.nivel"
                                  row
                                >
                                  <v-radio label="Privado" value="privado"></v-radio>
                                  <v-radio label="Público" value="publico"></v-radio>
                                </v-radio-group>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </template>
                      <template v-slot:no-data>
                        Nenhum anexo encontrado.
                      </template>
                    </v-data-iterator>
                    <vue-dropzone
                      ref="myVueDropzone"
                      id="dropzone"
                      duplicateCheck
                      @vdropzone-success="onFileUploaded"
                      @vdropzone-files-added="onFilesAdded"
                      @vdropzone-error="onFileError"
                      @vdropzone-queue-complete="finished($refs.editForm)"
                      :options="dropzoneOptions"
                    ></vue-dropzone>
                  </v-col>
                </v-row>
              </v-form>
              <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn
                  color="accent"
                  class="mr-5"
                  text
                  :loading="loading"
                  :to="{ name: 'Acervo listar' }"
                  >Cancelar</v-btn
                >
                <v-btn color="primary" rounded large :loading="loading" @click="onEditSave($refs)">
                  <span v-if="isOperador">
                    {{ editItem.statusFluxo == "EV" ? "Salvar" : "Enviar para análise" }}
                  </span>
                  <span v-else>{{ $route.params.id ? "Salvar" : "Adicionar" }}</span>
                </v-btn>
              </v-card-actions>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { VueEditor } from 'vue2-editor';
import vue2Dropzone from 'vue2-dropzone';
import { baseURL } from '@/services/container';
import formRules from '@/mixins/form-rules';
import viewTitle from '@/components/view-title.vue';
import formTitle from '@/components/form-title.vue';
import collectionUpsertDepoimentos from '@/components/collection-upsert-depoimentos.vue';
import collectionUpsertAudiovisual from '@/components/collection-upsert-audiovisual.vue';
import collectionUpsertFotografico from '@/components/collection-upsert-fotografico.vue';
import collectionUpsertTextual from '@/components/collection-upsert-textual.vue';
import collectionUpsertPecas from '@/components/collection-upsert-pecas.vue';
import collectionUpsertReferencia from '@/components/collection-upsert-referencia.vue';
import anexoImage from '@/components/collection-anexo-image.vue';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

export default {
  mixins: [formRules],
  components: {
    viewTitle,
    formTitle,
    vueDropzone: vue2Dropzone,
    VueEditor,
    collectionUpsertDepoimentos,
    collectionUpsertAudiovisual,
    collectionUpsertFotografico,
    collectionUpsertPecas,
    collectionUpsertTextual,
    collectionUpsertReferencia,
    anexoImage,
  },
  data() {
    return {
      baseURL,
      showPass: false,
      customToolbar: [
        ['bold', 'italic', 'underline'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['code-block'],
      ],
      dropzoneOptions: {
        autoProcessQueue: false,
        url: `${baseURL}/upload`,
        thumbnailWidth: 150,
        maxFilesize: 25000,
        timeout: 172000000,
        parallelUploads: 1,
        dictDefaultMessage: '<br>Clique ou arraste os arquivos aqui',
        dictFallbackMessage: 'Browser incompatível',
        dictInvalidFileType: 'Tipo de arquivo não suportado.',
        dictResponseError: 'Erro ao realizar upload',
        dictCancelUpload: 'Cancelar Upload',
        dictRemoveFile: 'Remover Arquivo',
        dictFileTooBig: 'Arquivo muito grande. Tamanho máximo dos arquivos 50MB',
        addRemoveLinks: true,
        renameFile(file) {
          const splitName = file.name.split('.');
          const extension = splitName.pop();
          const name = splitName.join('.');
          file.renameFilename = `${name}.${extension}`;
          return file.renameFilename;
        },
        init() {
          this.on('maxfilesexceeded', function remove(file) {
            this.removeAllFiles();
            this.addFile(file);
          });
        },
      },
      palavraChave: '',
      linkExterno: '',
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.afterRouteUpdate(to);
    });
  },
  beforeRouteUpdate(to, from, next) {
    this.afterRouteUpdate(to);
    next();
  },
  beforeRouteLeave(to, from, next) {
    this.clean();
    next();
  },
  computed: mapGetters('views/collection/upsert', [
    'acervo',
    'loading',
    'loadingBulkDocumentos',
    'editItem',
    'segmentos',
    'idiomas',
    'suportes',
    'estados',
    'palavrasChave',
    'documentos',
    'tiposObjeto',
    'familiaPublicacoes',
    'familias',
    'linksExternos',
    'isAdmin',
    'isOperador',
    'footerProps',
    'options',
    'selectedDocumentos',
    'selectedDocumentosCount',
    'hasSelectedDocumentos',
    'isAllDocumentosSelected',
  ]),
  methods: {
    ...mapActions('views/collection/upsert', [
      'afterRouteUpdate',
      'onEditChange',
      'onEditDocumento',
      'onEditSave',
      'onAddPalavrasChave',
      'onDeletePalavrasChave',
      'onAddLinkExterno',
      'onDeleteLinkExterno',
      'onFileUploaded',
      'onFileUploadFinish',
      'finished',
      'onDeleteDocumento',
      'onEditFamiliasChange',
      'clean',
      'onFileError',
      'onFilesAdded',
      'onAddSb',
      'onRemoveSb',
      'onPatchSb',
      'onBulkUpdateNivelDocumentos',
      'onBulkDeleteDocumentos',
      'onToggleSelectDocumento',
      'onSelectAllDocumentos',
      'onDeselectAllDocumentos',
    ]),
    onSelectAllChange(value) {
      if (value) {
        this.onSelectAllDocumentos();
      } else {
        this.onDeselectAllDocumentos();
      }
    },
    confirmBulkDeleteSelected() {
      if (this.selectedDocumentosCount > 0) {
        const message = `Você tem certeza que deseja deletar ${this.selectedDocumentosCount} ${this.selectedDocumentosCount === 1 ? 'documento selecionado' : 'documentos selecionados'}? Esta ação não pode ser desfeita.`;
        // eslint-disable-next-line no-alert
        if (window.confirm(message)) {
          this.onBulkDeleteDocumentos();
        }
      }
    },
  },
};
</script>
<style scoped>
.ck-editor__editable {
  min-height: 500px;
}
#upload >>> #dropzone.vue-dropzone > .dz-preview .dz-progress .dz-upload {
  background: green;
}
</style>
